
    (function () {
  const buttonData = document.getElementById(
    "tp-box-now-drawer-lockers-button-data"
  );
  console.log(buttonData);
  const partnerId = buttonData?.dataset?.partnerId;
  const drawerSelector = buttonData?.dataset?.drawerSelector;
  const lockerCountrySelector = buttonData?.dataset?.countrySelector;
  const selectedMessage = buttonData?.dataset?.selectedMessage;
  const countryOptions = JSON.parse(buttonData?.dataset?.countryOptions);
  const unselectButtonText = buttonData?.dataset?.unselectButtonText;
  const selectCountryText = buttonData?.dataset?.selectCountryText;
  const userSelectedMultipleCountries =
    lockerCountrySelector?.split(",")?.length > 1;

  if (partnerId && drawerSelector) {
    function clearLockerSelection(event) {
      event?.preventDefault();
      // Remove cart attributes from the cart
      const formData = new FormData();
      formData.append("attributes[boxnow_locker_address]", "");
      formData.append("attributes[boxnow_locker_name]", "");
      formData.append("attributes[boxnow_locker_id]", "");
      formData.append("attributes[boxnow_locker_country]", "");

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          // Hide the selected locker details container
          const lockerName = document.querySelector(
            ".tp-drawer-locker-name-text"
          );
          const lockerInfoWrapper = document.querySelector(
            ".tp-drawer-locker-info-wrapper"
          );
          if (lockerName && lockerInfoWrapper) {
            lockerName.textContent = "";
            lockerInfoWrapper.style.display = "none";
          }
        })
        .catch((error) => console.log(error));
    }

    const addButtonToCart = (
      hasCartItems = false,
      selectedLockerName = null
    ) => {
      const cartDrawer = document.querySelector(drawerSelector);
      const buttonBackgroundColor =
        buttonData?.dataset?.backgroundColor || "#44d62c";
      const buttonTextColor = buttonData?.dataset?.textColor || "#ffffff";
      const buttonText = buttonData?.dataset?.text || "SELECT BOX NOW LOCKER";
      const cartHasProducts =
        Number(buttonData?.dataset?.cartItemsCount) || hasCartItems;
      if (
        cartDrawer &&
        cartHasProducts &&
        !document.getElementById("tp-box-now-drawer-lockers-button")
      ) {
        if (cartDrawer) {
          if (userSelectedMultipleCountries) {
            // Create the wrapper div
            const countrySelectWrapper = document.createElement("div");
            countrySelectWrapper.classList.add(
              "tp-box-now-drawer-country-select-wrapper"
            );

            // Create the label
            const countryLabel = document.createElement("label");
            countryLabel.setAttribute(
              "for",
              "tp-box-now-drawer-locker-selection__country-select"
            );
            countryLabel.textContent = selectCountryText || "Select Country:";

            // Create the select
            const countrySelect = document.createElement("select");
            countrySelect.classList.add(
              "tp-box-now-drawer-locker-selection__country-select"
            );
            countrySelect.addEventListener("change", clearLockerSelection);

            // Create the options
            if (Array.isArray(countryOptions)) {
              countryOptions?.forEach((option) => {
                if (option?.key && option?.value) {
                  const optionElement = document.createElement("option");
                  optionElement.value = option?.key;
                  optionElement.textContent = option?.value;
                  countrySelect.appendChild(optionElement);
                }
              });
            }
            // Add the label and select to the wrapper div
            countrySelectWrapper.appendChild(countryLabel);
            countrySelectWrapper.appendChild(countrySelect);
            cartDrawer.appendChild(countrySelectWrapper);
          }
          const button = document.createElement("button");
          button.textContent = buttonText;
          button.style.color = buttonTextColor;
          button.style.backgroundColor = buttonBackgroundColor;
          button.id = "tp-box-now-drawer-lockers-button";
          button.addEventListener("click", () => {
            document.getElementById("tp-box-now-dialog")?.showModal();
          });
          cartDrawer.appendChild(button);

          // Create an info wrapper
          const lockerInfoWrapper = document.createElement("div");
          lockerInfoWrapper.classList.add("tp-drawer-locker-info-wrapper");

          const lockerNameWrapper = document.createElement("div");
          lockerNameWrapper.classList.add("tp-drawer-locker-name-wrapper");

          const lockerNameLabel = document.createElement("span");
          lockerNameLabel.textContent = "";
            //selectedMessage || "Selected Locker Name:";
          const lockerNameText = document.createElement("span");
          lockerNameText.classList.add("tp-drawer-locker-name-text");
          lockerNameText.textContent = selectedLockerName;
          lockerNameWrapper.appendChild(lockerNameLabel);
          lockerNameWrapper.appendChild(lockerNameText);

          const lockerActionsWrapper = document.createElement("div");
          lockerActionsWrapper.classList.add(
            "tp-drawer-locker-actions-wrapper"
          );

          // Create locker remove button
          const removeLockerButton = document.createElement("button");
          removeLockerButton.textContent = unselectButtonText || "Remove";
          removeLockerButton.classList.add("tp-drawer-locker-remove-button");
          removeLockerButton.addEventListener("click", clearLockerSelection);
          lockerActionsWrapper.appendChild(removeLockerButton);

          if (!selectedLockerName) {
            lockerInfoWrapper.style.display = "none";
          }

          // Add elements to the wrapper div
          lockerInfoWrapper.appendChild(lockerNameWrapper);
          lockerInfoWrapper.appendChild(lockerActionsWrapper);

          // Add the wrapper div to the cart drawer
          cartDrawer.appendChild(lockerInfoWrapper);
          if (
            window?._bnclient_map_widget &&
            typeof window?._bnclient_map_widget === "function"
          ) {
            window._bnclient_map_widget();
          }
        }
      }
    };

    const waitForDrawerAndInsertWidget = () => {
      const targetNode = document.body;
      const observerOptions = {
        childList: true,
        subtree: true,
      };

      const observerDrawer = new MutationObserver((mutationsList) => {
        const drawer = document.querySelector(drawerSelector);
        const buttonAlreadyExists = document.getElementById(
          "tp-box-now-drawer-lockers-button"
        );

        if (drawer && !buttonAlreadyExists) {
          fetch(`${window.Shopify.routes.root}cart.js`)
            .then((response) => response.json())
            .then((cart) => {
              if (cart?.item_count > 0) {
                addButtonToCart(true, cart?.attributes?.boxnow_locker_name);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });

      observerDrawer.observe(targetNode, observerOptions);
    };

    document.addEventListener("DOMContentLoaded", function () {
      const drawer = document.querySelector(drawerSelector);
      const buttonAlreadyExists = document.getElementById(
        "tp-box-now-drawer-lockers-button"
      );
      if (drawer && !buttonAlreadyExists) {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            if (cart?.item_count > 0) {
              addButtonToCart(true, cart?.attributes?.boxnow_locker_name);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      waitForDrawerAndInsertWidget();
    });

    // Observes performance entries to detect cart updates and removes the BoxNow widget if the cart is empty
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (
          entry.name.includes("cart/update") ||
          entry.name.includes("cart/change") ||
          entry.name.includes("cart/add")
        ) {
          fetch(`${window.Shopify.routes.root}cart.js`)
            .then((response) => response.json())
            .then((cart) => {
              if (cart.item_count === 0) {
                document
                  .getElementById("tp-box-now-drawer-lockers-button")
                  ?.remove();
              } else if (
                !document.getElementById("tp-box-now-drawer-lockers-button")
              ) {
                const scriptSrc =
                  "https://widget-cdn.boxnow.gr/map-widget/client/v5.js";

                var e = document.createElement("script");
                e.src = scriptSrc;
                e.async = true;
                e.defer = true;
                document.getElementsByTagName("head")[0].appendChild(e);
                addButtonToCart(true, cart?.attributes?.boxnow_locker_name);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    });
    observer.observe({ type: "resource", buffered: true });

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === "IFRAME" && node.src.includes("boxnow")) {
            const countryCode = userSelectedMultipleCountries
              ? document?.querySelector(
                  ".tp-box-now-drawer-locker-selection__country-select"
                )?.value
              : lockerCountrySelector;
            if (countryCode) {
              const iframeSrc = `https://widget-v5.boxnow.${countryCode}/popup.html?partnerId=${partnerId}&gps=yes&autoselect=yes&autoclose=yes`;
              node.src = iframeSrc;
            }
          }
        });
      });
    });
    mutationObserver.observe(buttonData, { childList: true });

    // Configuration for the BoxNow map widget
    // - `partnerId`: The unique partner ID required for authentication
    // - `parentElement`: The container where the map widget will be rendered
    // - `buttonSelector`: The button that triggers the map widget
    // - `afterSelect`: Callback function executed after a locker is selected
    //    - Retrieves locker details (ID, name, address, postal code)
    //    - Updates the Shopify cart attributes with the selected locker information
    window._bn_map_widget_config = {
      partnerId: partnerId,
      buttonSelector: "#tp-box-now-drawer-lockers-button",
      type: "popup",
      parentElement: "#tp-box-now-drawer-lockers-button-data",
      afterSelect: function (selected) {
        document.getElementById("tp-box-now-dialog")?.close();
        if (!selected?.boxnowLockerId) {
          return;
        }
        const boxnowLockerAddress = `${selected.boxnowLockerAddressLine1}, ${selected.boxnowLockerAddressLine2}, ${selected.boxnowLockerPostalCode}`;
        const boxnowLockerName = selected.boxnowLockerName;
        const boxnowLockerId = selected.boxnowLockerId;

        const formData = new FormData();
        formData.append(
          "attributes[boxnow_locker_address]",
          boxnowLockerAddress
        );
        formData.append("attributes[boxnow_locker_name]", boxnowLockerName);
        formData.append("attributes[boxnow_locker_id]", boxnowLockerId);
        if (userSelectedMultipleCountries) {
          const boxnowLockerCountry = document.querySelector(
            ".tp-box-now-drawer-locker-selection__country-select"
          );
          if (boxnowLockerCountry?.value) {
            formData.append(
              "attributes[boxnow_locker_country]",
              boxnowLockerCountry.value.toUpperCase()
            );
          }
        } else if (lockerCountrySelector) {
          formData.append(
            "attributes[boxnow_locker_country]",
            lockerCountrySelector.toUpperCase()
          );
        }

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            const lockerName = document.querySelector(
              ".tp-drawer-locker-name-text"
            );
            const lockerInfoWrapper = document.querySelector(
              ".tp-drawer-locker-info-wrapper"
            );
            if (lockerName && lockerInfoWrapper) {
              lockerName.textContent = response?.attributes?.boxnow_locker_name;
              lockerInfoWrapper.style.display = "flex";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
    };
    // Dynamically loads the BoxNow map widget script
    // - Creates a new <script> element and sets its source to the BoxNow widget URL
    // - Uses `async` and `defer` to load the script efficiently without blocking page rendering
    // - Appends the script to the <head>, making the BoxNow widget available on the page
    (function (d) {
      const scriptSrc = "https://widget-cdn.boxnow.gr/map-widget/client/v5.js";

      const existingScript = d.querySelector(`script[src="${scriptSrc}"]`);

      if (!existingScript) {
        var e = d.createElement("script");
        e.src = scriptSrc;
        e.async = true;
        e.defer = true;
        d.getElementsByTagName("head")[0].appendChild(e);
      }
    })(document);
  }
})();

